<script>

  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  const contact = {
    subject: null,
    message: null,
  }

  function sendUser() {
    dispatch('formEdited', contact)
  }
</script>

<label class="auth__label" for="message">

  Subject

  <div class="auth__input">

    <div class="auth__input-select">

      <select bind:value={contact.subject} class:disabled={!contact.subject} required>
        <option value="" disabled selected>Select your option</option>
        <option value="mentors">Questions about Mentors</option>
        <option value="support">I haven't heard back</option>
        <option value="feedback">General feedback</option>
      </select>

    </div>

  </div>

</label>

<label class="auth__label" for="message">

  How can we help?

  <div class="auth__input">

    <textarea type="text" name="message" on:keyup={sendUser} placeholder="Write your message" bind:value={contact.message} id="email" required />

  </div>

</label>

<style lang="scss">
 
</style>